import React, { useState } from "react";

const MyCommentDashboard = ({ comment }) => {
  const [moreInfo, setMoreInfo] = useState(false);
  const recommendStatus = {
    0: { color: "red", text: "پیشنهاد نمیکنم", icon: "icon-dislike" },
    1: { color: "green", text: "پیشنهاد میکنم", icon: "icon-like" },
    2: { color: "yellow", text: "مطمعن نیستم", icon: "icon-not-sure" },
  };

  // <i className={recommendStatus[comment?.is_recommended]?.icon} />;

  return (
    <main className="myCommentDashboard">
      <div className="commentHeader">
        <img src={comment?.images} className="commentImg" />
        <div className="info">
          <span className="commentTitle">{comment?.details?.title}</span>
          <div className="properties">
            <div
              className={`suggest ${
                recommendStatus[comment?.is_recommended]?.color
              }`}
            >
              <i className={recommendStatus[comment?.is_recommended]?.icon} />
              <span>{recommendStatus[comment?.is_recommended]?.text}</span>
            </div>
            <div className="subInfo">
              <span
                className={`status ${comment?.status === 0 ? "red" : "green"}`}
              >
                {comment?.status === 0 ? "تایید نشده" : "تایید شده"}
              </span>
              <div className="rate">
                <span>{comment?.rate}</span>
                <i className="icon-shooting-star" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`commentBody ${
          comment?.details.advantages?.length !== 0 ||
          comment?.details.disadvantages?.length !== 0
            ? "borderBottom"
            : ""
        }`}
      >
        <p>{comment?.details?.text}</p>
      </div>
      {comment?.details.advantages?.length !== 0 ||
      comment?.details.disadvantages?.length !== 0 ? (
        <div className="commentProps">
          {comment.details.advantages ? (
            <ul>
              {comment.details.advantages.map((advantage) => (
                <li className="green">+ {advantage}</li>
              ))}
            </ul>
          ) : (
            ""
          )}
          {comment.details.disadvantages ? (
            <ul>
              {comment.details.disadvantages.map((disadvantages) => (
                <li className="red">- {disadvantages}</li>
              ))}
            </ul>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </main>
  );
};

export default MyCommentDashboard;
